import { render } from "./custom-router.vue?vue&type=template&id=3f820430&scoped=true"
import script from "./custom-router.vue?vue&type=script&lang=js"
export * from "./custom-router.vue?vue&type=script&lang=js"

import "./custom-router.vue?vue&type=style&index=0&id=3f820430&lang=scss&scoped=true"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f820430"]])

export default __exports__